module.exports = __webpack_public_path__ + "img/suit-club.8e60b9d2.svg";